import { Injectable, ViewContainerRef } from '@angular/core';
import { ITransactionOverride } from './transaction-override.interface';
import { TransactionOverrideService } from './transaction-override.service';
import { TitleRegistrationTransactionOverrideService } from './title-registration-transaction-override.service';
import { FinanceTransactionOverrideService } from './finance-transaction-override.service';
import { DriverTransactionOverrideService } from './driver-transaction-override.service';
import { ProhibitionComplianceTransactionOverrideService } from './prohibition-compliance-transaction-override.service';
import { CaseTransactionOverrideService } from './case-transaction-override.service';
import { IRPTransactionOverrideService } from './irp-transaction-override.service';
import { CommercialPermittingTransactionOverrideService } from './commercial-permitting-transaction-override.service';
import { AircraftTransactionOverrideService } from './aircraft-transaction-override.service';

@Injectable()
export class TransactionOverrideFactory {
    private services: TransactionOverrideService[];

    constructor(
        private titleRegistrationTransactionOverrideService: TitleRegistrationTransactionOverrideService,
        private financeTransactionOverrideService: FinanceTransactionOverrideService,
        private driverTransactionOverrideService: DriverTransactionOverrideService,
        private prohibitionComplianceTransactionOverrideService: ProhibitionComplianceTransactionOverrideService,
        private caseTransactionOverrideService: CaseTransactionOverrideService,
        private irpTransactionOverrideService: IRPTransactionOverrideService,
        private commercialPermittingTransactionOverrideService: CommercialPermittingTransactionOverrideService,
        private aircraftTransactionOverrideService: AircraftTransactionOverrideService
    ) {
        this.services = [];
        this.services.push(titleRegistrationTransactionOverrideService);
        this.services.push(financeTransactionOverrideService);
        this.services.push(driverTransactionOverrideService);
        this.services.push(prohibitionComplianceTransactionOverrideService);
        this.services.push(caseTransactionOverrideService);
        this.services.push(irpTransactionOverrideService);
        this.services.push(commercialPermittingTransactionOverrideService);
        this.services.push(aircraftTransactionOverrideService);
    }

    /**
     * Get the route builder for the specified source system
     */
    public create(sourceSystemTypeId: number, viewContainerRef: ViewContainerRef): ITransactionOverride {
        const s = this.services.find(s => s.sourceSystemType.id == sourceSystemTypeId);
        s.ViewContainer = viewContainerRef;
        return s;
    }
}
